export const APPROVED = 'approved';
export const COMPLETE = 'complete';
export const CURRENT = 'current';
export const INCOMPLETE = 'incomplete';
export const NOT_APPROVED = 'notApproved';
export const PAST_DUE = 'pastDue';
export const PENDING_APPROVAL = 'pendingApproval';
export const INFO_REQUIRED = 'infoRequired';
export const CANCELED = 'canceled';
